import React, { useEffect, useState } from "react";
import "./App.css";
import lottery from "./lottery";
import web3 from "./web3";
import Footer from "./components/Footer";
import Contact from "./components/Contact";

function App() {
  const [value, setValue] = useState("");
  const [message, setMessage] = useState<any>("");
  const [manager, setManager] = useState<any>("");
  const [players, setPlayers] = useState<any>([]);
  const [balance, setBalance] = useState<any>("");

  useEffect(() => {
    const loadManager = async () => {
      const manager = await lottery.methods.manager().call();
      setManager(manager);
    };

    const loadPlayers = async () => {
      const players = await lottery.methods.getPlayers().call();
      setPlayers(players);
    };

    const loadBalance = async () => {
      const balance = await web3.eth.getBalance(lottery.options.address ?? "");
      setBalance(balance);
    };

    loadManager();
    loadPlayers();
    loadBalance();
  }, []);

  const onSubmit = async (event: any) => {
    event.preventDefault();
    const accounts = await web3.eth.getAccounts();

    setMessage("Waiting on transaction success...");

    await lottery.methods.enter().send({
      from: accounts[0],
      value: web3.utils.toWei(value, "ether"),
    });

    setMessage("You have been entered!");
  };

  const onClick = async () => {
    const accounts = await web3.eth.getAccounts();

    setMessage("Waiting on transaction success...");

    await lottery.methods.pickWinner().send({
      from: accounts[0],
    });

    setMessage("A winner has been picked!");
  };

  return (
    <div>
      <header id="header" className="fixed-top ">
        <div className="container d-flex align-items-center justify-content-between">
          <h1 className="logo my-3">
            <a href="index.html">RSoft Lottery</a>
          </h1>
        </div>
      </header>

      <section id="hero" className="d-flex align-items-center">
        <div className="container-fluid" data-aos="fade-up">
          <div className="row justify-content-center">
            <div className="col-xl-5 col-lg-6 pt-3 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
              <h1>Want to try your luck ?</h1>
              <h2>
                This contract is maneged by {manager}. There are currently{" "}
                {players.length} people entered, competing to win{" "}
                {web3.utils.fromWei(balance, "ether")} ether!
              </h2>
              <div className="my-5">
                <form onSubmit={onSubmit}>
                  <div>
                    <label htmlFor="enter" className="form-label">
                      Amount of ether to enter
                    </label>
                    <input
                      id="enter"
                      className="form-control"
                      value={value}
                      type="number"
                      onChange={(event) => setValue(event.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn-get-started">
                    Enter
                  </button>
                </form>

                <hr />

                <h2>Ready to pick a winner ?</h2>
                <button className="btn-get-started" onClick={onClick}>
                  Pick a winner
                </button>

                <hr />

                <h1>{message}</h1>
              </div>
            </div>
            <div
              className="col-xl-4 col-lg-6 order-1 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="150"
            >
              <img
                src="assets/img/lottery.png"
                className="img-fluid animated"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <main>
        <Contact />
      </main>

      <Footer />

      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short" />
      </a>
    </div>
  );
}

export default App;
